import { styled } from "@mui/material";

export const StyledFooter = styled("footer")({
    marginBlock: "16px",
    width: "100%",
});
